import { selectMediaState } from 'redux/modules/device';

const SET_VISIBLE_VENUES = 'classpass/search/SET_VISIBLE_VENUES';
const SET_CURRENT_PAGE = 'classpass/search/SET_CURRENT_PAGE';
const SET_RELOAD_CURSOR = 'classpass/search/SET_RELOAD_CURSOR';
const SET_SEARCH_ID = 'classpass/search/SET_SEARCH_ID';
const SET_ACTIVE_URL = 'classpass/search/SET_ACTIVE_URL';
const SET_FILTERING_DISABLED = 'classpass/search/SET_FILTERING_DISABLED';
const SET_MAP_VIEW = 'classpass/search/SET_MAP_VIEW';
const SET_FILTERS_FROM_HASH = 'classpass/search/SET_FILTERS_FROM_HASH';
export const TOGGLE_MAP_VIEW = 'classpass/search/TOGGLE_MAP_VIEW';
export const SET_IS_IN_VENUE_SUPPLY = 'classpass/search/SET_IS_IN_VENUE_SUPPLY';

export const setCurrentPage = value => ({ type: SET_CURRENT_PAGE, key: 'currentPage', value });
export const setReloadCursor = value => ({ type: SET_RELOAD_CURSOR, key: 'reloadCursor', value });
export const setSearchId = value => ({ type: SET_SEARCH_ID, key: 'searchId', value });
export const setActiveUrl = value => ({ type: SET_ACTIVE_URL, key: 'activeUrl', value });
export const setFilteringDisabled = value => ({ type: SET_FILTERING_DISABLED, key: 'filteringDisabled', value });
export const setupFilters = filters => ({ type: SET_FILTERS_FROM_HASH, filters });
export const setVisibleVenues = value => ({ type: SET_VISIBLE_VENUES, key: 'visibleVenues', value });
export const setMapView = value => ({ type: SET_MAP_VIEW, key: 'isMapView', value });
export const toggleMapView = () => ({ type: TOGGLE_MAP_VIEW });
export const setIsInVenueSupply = value => ({ type: SET_IS_IN_VENUE_SUPPLY, key: 'isInVenueSupply', value });

const selectSearchState = state => state.features.search;
export const selectVisibleVenues = state => selectSearchState(state).visibleVenues;
export const selectCurrentPage = state => selectSearchState(state).currentPage;
export const selectReloadCursor = state => selectSearchState(state).reloadCursor;
export const selectSearchId = state => selectSearchState(state).searchId;
export const selectActiveUrl = state => selectSearchState(state).activeUrl;
export const selectFilteringDisabled = state => selectSearchState(state).filteringDisabled;
export const selectMapView = state => selectSearchState(state).isMapView;
export const selectIsMapToggleable = state => !selectMediaState(state).lg;
export const selectIsInVenueSupply = state => selectSearchState(state).isInVenueSupply;

const initialState = {
  currentPage: 1,
  reloadCursor: '',
  searchId: null,
  activeUrl: '',
  filteringDisabled: false,
  isMapView: false,
  visibleVenues: null,
  isInVenueSupply: false,
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_VISIBLE_VENUES:
    case SET_CURRENT_PAGE:
    case SET_RELOAD_CURSOR:
    case SET_SEARCH_ID:
    case SET_ACTIVE_URL:
    case SET_FILTERING_DISABLED:
    case SET_IS_IN_VENUE_SUPPLY:
    case SET_MAP_VIEW:
      return {
        ...state,
        [action.key]: action.value,
      };
    case TOGGLE_MAP_VIEW:
      return {
        ...state,
        isMapView: !state.isMapView,
      };
    default:
      return state;
  }
}
